import { DonatePageContent } from './components/donate-page-content/DonatePageContent';

export const DonatePageAdmin = () => {
    return <DonatePageContent />;
};
